import unescapedText from 'I18n/utils/unescapedText';
// this is a function so unescapedText is not called before it can be used
const buildBaseFilterConfig = () => ({
  ProductType: {
    dataType: 'STRING',
    field: 'PRODUCT_TYPE',
    placeholder: unescapedText('marketplaceStorefront.filters.universal.productType.placeholder'),
    options: [{
      text: unescapedText('marketplaceStorefront.filters.universal.productType.APP'),
      value: 'APP'
    }, {
      text: unescapedText('marketplaceStorefront.filters.universal.productType.AGENT'),
      value: 'AGENT'
    }]
  },
  PortalInstallable: {
    dataType: 'BOOLEAN',
    field: 'PORTAL_INSTALLABLE',
    allowedAppContext: 'app',
    placeholder: unescapedText('marketplaceStorefront.filters.universal.compatiblePlan.placeholder'),
    defaultValue: 'any',
    options: [{
      text: unescapedText('marketplaceStorefront.filters.universal.compatiblePlan.anyPlan'),
      value: 'any'
    }, {
      text: unescapedText('marketplaceStorefront.filters.universal.compatiblePlan.myPlanOnly'),
      value: 'true'
    }]
  },
  PricingPlan: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'PRICING_PLAN',
    label: unescapedText('marketplaceStorefront.filters.app.pricingPlan.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.pricingPlan.placeholder')
  },
  HubspotFeatures: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'HUBSPOT_FEATURES',
    label: unescapedText('marketplaceStorefront.filters.app.hubspotFeatures.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.hubspotFeatures.placeholder')
  },
  Certified: {
    productType: 'APP',
    dataType: 'BOOLEAN',
    field: 'CERTIFIED',
    label: unescapedText('marketplaceStorefront.filters.app.certified.label'),
    options: [{
      text: unescapedText('marketplaceStorefront.filters.app.certified.label'),
      value: 'true'
    }]
  },
  SyncDirection: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'SYNC_DIRECTION',
    label: unescapedText('marketplaceStorefront.filters.app.syncDirection.label')
  },
  AppLanguages: {
    productType: 'APP',
    dataType: 'STRING',
    isLanguage: true,
    field: 'APP_LANGUAGES',
    label: unescapedText('marketplaceStorefront.filters.app.appLanguages.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.appLanguages.placeholder')
  },
  SupportLanguages: {
    productType: 'APP',
    dataType: 'STRING',
    isLanguage: true,
    field: 'SUPPORT_LANGUAGES',
    label: unescapedText('marketplaceStorefront.filters.app.supportLanguages.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.supportLanguages.placeholder')
  },
  Category: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'CATEGORY',
    label: unescapedText('marketplaceStorefront.filters.app.category.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.category.placeholder')
  },
  ToolIntegrations: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'TOOL_INTEGRATIONS',
    label: unescapedText('marketplaceStorefront.filters.app.toolIntegrations.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.toolIntegrations.placeholder')
  },
  BuiltByHubspot: {
    productType: 'APP',
    dataType: 'BOOLEAN',
    field: 'BUILT_BY_HUBSPOT',
    label: unescapedText('marketplaceStorefront.filters.app.builtByHubspot.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.builtByHubspot.label'),
    defaultValue: 'all',
    options: [{
      text: unescapedText('marketplaceStorefront.filters.app.builtByHubspot.all'),
      value: 'all'
    }, {
      text: unescapedText('marketplaceStorefront.filters.app.builtByHubspot.hubspot'),
      value: 'true'
    }, {
      text: unescapedText('marketplaceStorefront.filters.app.builtByHubspot.partners'),
      value: 'false'
    }]
  }
});
let baseFilterConfig;
export function getBaseFilterConfig() {
  if (!baseFilterConfig) baseFilterConfig = buildBaseFilterConfig();
  return baseFilterConfig;
}